export const ALERT_STATUS = {
  ACTIVE: 'ACTIVE',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  COMPLETED: 'COMPLETED',
  DISMISSED: 'DISMISSED',
} as const;

export const ALERT_SIGNAL_TYPE = {
  WEIGHT_OFF_TRACK: 'WEIGHT_OFF_TRACK',
} as const;

export const ALERT_DISMISS_REASON = {
  ALERT_NOT_APPLICABLE: 'ALERT_NOT_APPLICABLE',
  RECOMMENDED_ACTIONS_NOT_APPLICABLE: 'RECOMMENDED_ACTIONS_NOT_APPLICABLE',
  NO_ACTION_POSSIBLE: 'NO_ACTION_POSSIBLE',
  PATIENT_PAUSING_OR_DISCHARGING: 'PATIENT_PAUSING_OR_DISCHARGING',
  OTHER: 'OTHER',
} as const;

export const ALERT_DISMISS_REASON_LABEL = {
  [ALERT_DISMISS_REASON.ALERT_NOT_APPLICABLE]: 'Alert is not applicable',
  [ALERT_DISMISS_REASON.RECOMMENDED_ACTIONS_NOT_APPLICABLE]:
    'Recommended actions are not applicable',
  [ALERT_DISMISS_REASON.NO_ACTION_POSSIBLE]: 'No action possible',
  [ALERT_DISMISS_REASON.PATIENT_PAUSING_OR_DISCHARGING]:
    'Patient is pausing or discharging',
  [ALERT_DISMISS_REASON.OTHER]: 'Other',
} as const;
